export default __webpack_public_path__ + "static/media/paperclip.0577540e.svg";